export default __webpack_public_path__ + "static/media/ss-mynumber.7b27cf2b.png";